import { child, get, ref, set, update, remove } from "firebase/database";
import { db, bookingPlatformDb, convertedDataDb} from "../firebase";   

const readFromFBDB = (subpath, ref_str="") => {
    return new Promise(async (resolve, reject) => {
        try {
            let ref_db =  db
            if (ref_str === "bookingPlatformDb") ref_db = bookingPlatformDb
            if (ref_str === "convertedDataDb") ref_db = convertedDataDb
            const snapshot = await get(child(ref(ref_db), subpath));
            if (snapshot.exists()) {
                const data = snapshot.val();
                resolve({data});
            } else {
                console.error("No Data Found");
                reject({error:'No Data Found!'});
            }
        } catch (error) {
            console.error("Error reading from Firebase:", error.message);
            reject({error});
        }
    });
};

const writeToFBDB = async (subpath, payload, ref_str="") => {
    try {
        let ref_db =  db
        if(ref_str==="bookingPlatformDb") ref_db = bookingPlatformDb
        if(ref_str==="convertedDataDb") ref_db = convertedDataDb
        const dbRef = ref(ref_db, subpath);
        const snapshot = await set(dbRef, payload);
        return snapshot?.val();
    } catch(error){
        console.error("Error writing to Firebase:", error.message);
        throw error;
    }
};

const updateInFBDB = async (subpath, payload, ref_str = "") => {
    try {
        let ref_db =  db
        if(ref_str==="bookingPlatformDb") ref_db = bookingPlatformDb
        if(ref_str==="convertedDataDb") ref_db = convertedDataDb
        const dbRef = ref(ref_db, subpath);
        const snapshot = await update(dbRef, payload);
        return snapshot?.val();
    } catch (error) {
        console.error("Error updating in Firebase:", error.message);
        throw error;
    }
};

const updateValueInFBDB = async (subpath, value, ref_str = "") => {
    try {
        let ref_db = db;
        if (ref_str === "bookingPlatformDb") ref_db = bookingPlatformDb;
        if (ref_str === "convertedDataDb") ref_db = convertedDataDb;
        const dbRef = ref(ref_db, subpath);
        await set(dbRef, value); // Set updates a single value
        return value; // Return updated value
    } catch (error) {
        console.error("Error updating single value in Firebase:", error.message);
        throw error;
    }
};
const deleteFromFBDB = async (subpath , ref_str="") => {
    try {
        let ref_db =  db
        if(ref_str==="bookingPlatformDb") ref_db = bookingPlatformDb
        if(ref_str==="convertedDataDb") ref_db = convertedDataDb
        const dbRef = ref(ref_db, subpath);
        // const dbRef = ref(db, subpath);
        const snapshot = await remove(dbRef);
        return "data deletion done!"
        // return snapshot.val();
    } catch (error) {
        console.error("Error deleting from Firebase:", error.message);
        throw error;
    }
};

const getAllFBDBChildKeys = (subpath, ref_str = "") => {
    return new Promise(async (resolve, reject) => {
      try {
        let ref_db = db;
        if (ref_str === "bookingPlatformDb") ref_db = bookingPlatformDb;
        if (ref_str === "convertedDataDb") ref_db = convertedDataDb;
  
        // Get the snapshot of the data at the specified subpath
        const snapshot = await get(child(ref(ref_db), subpath));
  
          if (snapshot.exists()) {
              const childKeys = Object.keys(snapshot.val());
            //   console.log("childKeys", childKeys)
          resolve({ childKeys });
        } else {
          console.error("No Data Found");
          reject({ error: "No Data Found!" });
        }
      } catch (error) {
        console.error("Error reading from Firebase:", error.message);
        reject({ error });
      }
    });
  };

export {
    readFromFBDB,
    writeToFBDB,
    updateInFBDB,
    updateValueInFBDB,
    deleteFromFBDB,
    getAllFBDBChildKeys
};
